export default __webpack_public_path__ + "static/media/105.670d850a.png";